import { useEffect } from 'react';
import { useKeycloakReady } from 'hooks';
import { useProfileImage } from 'all-in-one-shared-api';
import { AvatarProps } from 'antd';

import { Avatar } from 'components/avatar';

interface ProfileAvatarProp extends AvatarProps {
  memberType: string;
}

export const ProfileAvatar = ({ memberType, ...props }: ProfileAvatarProp): JSX.Element => {
  const { ready, token } = useKeycloakReady();
  const { shouldFetch: fetchProfileImage, data: profileImageData } = useProfileImage(
    { name: 'getProfileImage', memberType },
    token ?? '',
    memberType,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
      refreshInterval: 7000, // For AIOBRB-1752
    },
  );

  const profileImage =
    !!profileImageData && profileImageData.length > 0
      ? profileImageData.find((profileImage) => profileImage.memberType === memberType)
      : undefined;
  const avatarUrl = profileImage ? profileImage.pictureUrl : '';

  useEffect(() => {
    fetchProfileImage(ready && !!memberType);
  }, [fetchProfileImage, ready, memberType]);

  return <Avatar avatarUrl={avatarUrl} {...props} />;
};
